import React, { useContext } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import type { TStencilStore } from '../../types/Stencil';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

function StencilBuilderSteps() {
  const { activePage } = useContext(WysiwygEditorStateContext);
  const allImagesPopulated = useSelector(
    (state: TStencilStore) => state.submission.allImagesPopulated
  );

  return (
    <div className="stencil-steps">
      <div className="stencil-steps-step stencil-steps-step--completed">
        <div className="stencil-steps-step-number">1</div>
        <div className="stencil-steps-step-label">Choose layout</div>
      </div>
      <div
        className={classnames('stencil-steps-step', {
          'stencil-steps-step--completed': allImagesPopulated
        })}
      >
        <div className="stencil-steps-step-number">2</div>
        <div className="stencil-steps-step-label">Add photos</div>
      </div>
      <div
        className={classnames('stencil-steps-step', {
          'stencil-steps-step--completed': activePage === 'preview'
        })}
      >
        <div className="stencil-steps-step-number">3</div>
        <div className="stencil-steps-step-label">Preview</div>
      </div>
      <div className="stencil-steps-step">
        <div className="stencil-steps-step-number">4</div>
        <div className="stencil-steps-step-label">Submit</div>
      </div>
    </div>
  );
}

export default StencilBuilderSteps;
